module.exports = __webpack_public_path__ + "static/media/nicole_hermosilla.630ae9fe.jpg";